import React, { useState } from 'react';
import './App.css';
import { login } from './api';
import { useNavigate } from 'react-router-dom';
import SignupModal from './SignupModal';

function App() {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');

  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [success, setSuccess] = React.useState(null);
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccess(null);
    setLoading(true);

    try {
      const resp = await login(userId, password);

      if (!resp.ok) {
        setError((resp.data && resp.data.error) || resp.error || 'Login failed');
        return;
      }

      const data = resp.data || {};
      if (data.access) localStorage.setItem('accessToken', data.access);
      if (data.refresh) localStorage.setItem('refreshToken', data.refresh);

  setSuccess('로그인에 성공했습니다.');
      setPassword('');
  // redirect to main
  navigate('/main');
    } catch (err) {
      console.error('Login error', err);
      setError('서버에 연결할 수 없습니다. CORS 또는 백엔드가 실행 중인지 확인하세요.');
    } finally {
      setLoading(false);
    }
  };

  const navigate = useNavigate();
  const [showSignup, setShowSignup] = useState(false);

  const openSignup = () => setShowSignup(true);
  const closeSignup = () => setShowSignup(false);

  return (
    <div className="app-root">
      <p className="form-note">한일 잉글리쉬 아카데미 다운로드 페이지</p>
      <form className="login-card" onSubmit={handleSubmit} aria-label="login form">
        <h1 className="login-title">Sign in</h1>

        <div className="form-group">
          <label htmlFor="userId">Username</label>
          <input
            id="userId"
            name="userId"
            type="text"
            value={userId}
            onChange={(e) => setUserId(e.target.value)}
            required
            autoFocus
            className="form-input"
          />
        </div>

        <div className="form-group">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            name="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            autoComplete="off"
            className="form-input"
          />
        </div>

        <div className="form-actions">
          <button type="button" className="signup-link" onClick={openSignup}>회원가입</button>
          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? '로딩...' : '로그인'}
          </button>
        </div>

        {error && <div className="error" role="alert">{error}</div>}
        {success && <div className="success" role="status">{success}</div>}

        <p className="login-help">로그인 정보를 입력하세요.</p>
      </form>
        {showSignup && <SignupModal onClose={closeSignup} />}
    </div>
  );
}

export default App;
